export default {
      id: "ic-misc-search-white-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic-misc-search-white-usage",
      toString: function () {
        return this.url;
      }
    }